import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.companyFreight',
    modules: [
        R,
    ],
})
@Service('CompanyFreightStore')
export default class Store extends BaseStore {

    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('company-freights');
    }

}



// WEBPACK FOOTER //
// ./src/app/stores/company.freight.js